export function isPhoneValid(phone: string) {
  const regex = /^\([1-9]{2}\) (?:[2-8]|9[1-9])[0-9]{3}-[0-9]{4}$/i

  return regex.test(phone) && phone.indexOf('99999') === -1
}
